import React, { useEffect, useMemo, useState } from "react";
import { useParams } from 'react-router';
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import ROUTES from "../../../../utilities/Routes";

import Stage from "../../../../components/Stage";
import ButtonBack from "../../../../components/Buttons/Back";
import InputText from "../../../../components/Inputs/Text";
import InputSelect from "../../../../components/Inputs/Select";
import InputTextArea from "../../../../components/Inputs/TextArea";
import InputCheckBox from "../../../../components/Inputs/Checkbox";
import ReactLoading from "react-loading";

import { getOnlyAudiCenters, scrollToInput } from "../../../../utilities/utils";

import {
    setTratamientoAction,
    setNombreAction,
    setApellidoPaternoAction,
    setMovilAction,
    setCorreoAction,
    setEstadoAction,
    setCiudadAction,
    setIdConcesionarioAction,
    setConcesionarioAction,
    setVehiculoAction,
    setComentariosAction,
    setAvisosDePrivacidadAction,
    setTerminosCondicionesAction,
    setTransferenciaDeDatosAction,
    reiniciarStateAction
} from "../../../../actions/vtpNuevosActions";

import {
    getEstados,
    getConcesionarios,
} from "../../../../API/CitasServicioRequest/index";

import {
    getCiudades,
} from "../../../../API/ConfiguradorRequest/index";

import {
    isOnlyNumbers,
} from "../../../../utilities/Validations";
import { sendLead, sendMailVtpNuevosCliente, sendMailVtpNuevosConcesionaria } from "../../../../API/VTPNuevosRequest";
import { buildTradeInPayload, validarApellidoPaterno, validarCelular, validarCodigoPostal, validarCorreo, validarNombre } from "../../../../utilities/Validations/lead";
import { sendLeadToSaas } from "../../../../API/SaasRequest";
import { TratoComponent } from "../../../../components/Form/Trato";
import { sendTradeIn } from "../../../../API/TradeInRequest";
import TradeInSection from "../../../../components/Form/TradeInSection";

const MODELSPREVENTA = ["A5 SEDAN"];

const FormVTPNuevo = () => {
    const dispatch = useDispatch();
    const objSubmit = useSelector((state) => state.vtpNuevos);

    const { vinId } = useParams();
    let navigate = useNavigate();

    const setTratamiento = (inTratamiento) => {
        dispatch(setTratamientoAction(inTratamiento));
    };
    const setNombre = (inNombre) => {
        dispatch(setNombreAction(inNombre));
    };
    const setApellidoPaterno = (inApellidoPaterno) => {
        dispatch(setApellidoPaternoAction(inApellidoPaterno));
    };
    const setMovil = (inMovil) => {
        dispatch(setMovilAction(isOnlyNumbers(inMovil)));
    };
    const setCorreo = (inCorreo) => {
        dispatch(setCorreoAction(inCorreo));
    };
    const setComentarios = (inComentarios) => {
        dispatch(setComentariosAction(inComentarios));
    };
    const setAvisosDePrivacidad = (inAvisosDePrivacidad) => {
        dispatch(setAvisosDePrivacidadAction(inAvisosDePrivacidad));
    };
    const setTerminosCondiciones = (inTerminosCondiciones) => {
        dispatch(setTerminosCondicionesAction(inTerminosCondiciones));
    };
    const setTransferenciaDeDatos = (inAvisosDePrivacidad) => {
        dispatch(setTransferenciaDeDatosAction(inAvisosDePrivacidad));
    };
    const setIdConcesionario = (inIdConcesionario) => {
        dispatch(setIdConcesionarioAction(inIdConcesionario));
    };
    const setConcesionario = (inConcesionario) => {
        dispatch(setConcesionarioAction(inConcesionario));
    };
    const setEstado = (inEstado) => {
        dispatch(setEstadoAction(inEstado));
    };
    const setCiudad = (inCiudad) => {
        dispatch(setCiudadAction(inCiudad));
    };

    const [infoNameForm,] = useState("Quiero un auto nuevo");
    const [infoImage,] = useState("form_vtpnuevos.jpg");

    const [concesionarios, setConcesionarios] = useState([]);

    const [modelToShow, setModelToShow] = useState('');
    const [caracteristicasToShow, setCaracteristicasToShow] = useState('');
    const [codigoPostal, setCodigoPostal] = useState('');
    const [tradeInData, setTradeInData] = useState(null);
    const [showErrorDeclaraciones, setErrorDeclaraciones] = useState(false);

    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [showErrorSubmit, setShowErrorSubmit] = useState(false);
    const [estados, setEstados] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [showErrorEstado, setErrorEstado] = useState(false);
    const [showErrorCiudad, setErrorCiudad] = useState(false);
    const [showErrorCodigoPostal, setErrorCodigoPostal] = useState(false);
    const [showErrorConcesionario, setErrorConcesionario] = useState(false);

    useEffect(() => {
        document.title = "Quiero un auto nuevo";

        if (process.env.REACT_APP_ENABLE_GA4 === "true") {
            // Se inicializa el objeto de analytics para el sitio
            ReactGA.initialize(process.env.REACT_APP_VTP_GA_ID);
        }

    }, []);

    const filterCiudades = useMemo(() => {
        if (estados.length > 0 && ciudades.length > 0) {
            const estadoSelected = estados.find(
                (edo) => edo.nombreedo === objSubmit.provincia
            );

            if (estadoSelected === undefined) return [];

            return ciudades.filter(
                (cd) => cd.idestado.idestado === estadoSelected.idestado
            );
        }
        return [];
    }, [objSubmit, estados, ciudades]);

    const filterConcesionarios = useMemo(() => {
        if (concesionarios.length > 0 && estados.length > 0) {
            const estadoSelected = estados.find(
                (edo) => edo.nombreedo === objSubmit.provincia
            );

            if (estadoSelected === undefined) return [];

            return concesionarios.filter(
                (concesionario) => concesionario.stateName === estadoSelected.nombreedo
            );
        }
        return [];
    }, [objSubmit.provincia, estados, concesionarios]);

    const onSubmit = (e) => {
        e.preventDefault();

        const dataIsvalid = validateForm();

        if (dataIsvalid) {
            setLoadingSubmit(true);
            setShowErrorSubmit(false);
            const lead = { ...objSubmit }

            lead.numeroConcesionaria = objSubmit.numeroConcesionaria < 1000
                ? "0" + objSubmit.numeroConcesionaria
                : "" + objSubmit.numeroConcesionaria

            lead.llaveOrigen = "AUSW" + new Date().getTime()

            delete lead.avisoPrivacidad
            delete lead.terminosCondiciones
            delete lead.nombreDelVehiculo

            const descripcionMail = lead.descripcion.trim() === "" ? "Sin comentarios" : lead.descripcion.trim();
            lead.descripcion = vinId + " - " + (lead.descripcion.trim() === "" ? "Sin comentarios" : lead.descripcion.trim());

            sendLead(lead)
                .then((response) => {
                    sendMailVtpNuevosCliente(lead)
                    sendMailVtpNuevosConcesionaria({ ...lead, vinId, descripcionMail });


                    if (tradeInData) {
                        sendTradeIn(buildTradeInPayload(lead, tradeInData, codigoPostal))
                            .then((res) => console.log("Trade-in enviado:", res))
                            .catch((err) => console.error("Error trade-in:", err));
                    }
                    setLoadingSubmit(false);
                    reiniciarStateAction();
                    handleSendLeadToSaas(lead, response?.data?.idTransaccion, true, "Formulario VTP Nuevos", response?.data?.message);

                    navigate(ROUTES.VTPNUEVOS + ROUTES.VTPNUEVOSTHANKYOUEMPTY + "/" + vinId)
                })
                .catch((error) => {
                    handleSendLeadToSaas(lead, error?.response?.data?.idTransaccion || null, false, "Formulario VTP Nuevos", error?.response?.data?.message || error?.message || "Error en envío de lead");
                    setLoadingSubmit(false);
                    setShowErrorSubmit(true);
                    console.log("ERROR: ", error);
                });
        }

    }

    const handleSendLeadToSaas = (lead, idTransaccion, status, model, message) => {
        sendLeadToSaas(lead, process.env.REACT_APP_VTP_NUEVO_FORM_ID, idTransaccion, status, model, message)
            .then(respuesta => {
                // manejar respuesta
            })
            .catch(error => {
                // manejar error
                console.error("Error en log: " + error)
            });
    }

    const validateForm = () => {
        if (validarNombre(objSubmit.nombre) === false) {
            scrollToInput("nombre", "Por favor ingresa un nombre válido");
            return false
        }
        if (validarApellidoPaterno(objSubmit.apellidoPaterno) === false) {
            scrollToInput("apellidoPaterno", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCelular(objSubmit.celular) === false) {
            scrollToInput("movil", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCorreo(objSubmit.email) === false) {
            scrollToInput("correo", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCodigoPostal(codigoPostal) === false) {
            scrollToInput("codigoPostal", "Por favor ingresa un valor válido");
            return false;
        }

        if (modelToShow.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(MODELSPREVENTA)) {

            if (objSubmit.provincia === "") {
                scrollToInput("estado");
                setErrorEstado(true);
                return false;
            } else {
                setErrorEstado(false);
            }
            if (objSubmit.ciudad === "") {
                scrollToInput("ciudad");
                setErrorCiudad(true);
                return false;
            } else {
                setErrorCiudad(false);
            }
            if (objSubmit.numeroConcesionaria === "" || objSubmit.concesionariaPreferida === "") {
                scrollToInput("concesionario");
                setErrorConcesionario(true);
                return false;
            } else {
                setErrorConcesionario(false);
            }
        }



        if (
            objSubmit.avisoPrivacidad === false ||
            objSubmit.terminosCondiciones === false ||
            objSubmit.permisoTransferenciaDatos === false
        ) {
            setErrorDeclaraciones(true);
            return false;
        } else {
            setErrorDeclaraciones(false);
        }

        return true
    }

    useEffect(() => {
        let arrayDataVehicle = JSON.parse(decodeURIComponent(localStorage.getItem("vehicleInfoVTPNuevo")));
        let onlyDataVehicle = arrayDataVehicle.filter(item => item.vehicleData);

        let vehiculoInteresDetail = onlyDataVehicle[0].vehicleData.symbolicCarline.description;
        let vehiculoInteres = onlyDataVehicle[0].vehicleData.symbolicCarline.description.replace("Audi ", "");
        let vehiculoInteresDescriptionDetail = onlyDataVehicle[0].vehicleData.modelCode.description;
        //let idCar = onlyDataVehicle[0].vehicleData.vin;

        let concesionarioDetail = onlyDataVehicle[0].vehicleData.dealer.name;
        //let leadConcesionariaPreferida = onlyDataVehicle[0].vehicleData.dealer.name;
        let concesionarioIDDetail = onlyDataVehicle[0].vehicleData.dealer.id;
        let concesionarioIDDetail2 = concesionarioIDDetail.substring(0, concesionarioIDDetail.length - 1);
        let concesionarioIDDetail3 = concesionarioIDDetail2.charAt(0) === '0' ? concesionarioIDDetail2.slice(1) : concesionarioIDDetail2;
        let provinciaDetail = onlyDataVehicle[0].vehicleData.dealer.city;
        //let leadProvincia = onlyDataVehicle[0].vehicleData.dealer.city;

        /*
        console.log("*********************************************************");
        console.log("1. Modelo           :   " + vehiculoInteresDetail);
        console.log("2. M Salesforce     :   " + vehiculoInteres);
        console.log("3. Caracteristicas  :   " + vehiculoInteresDescriptionDetail);
        console.log("4. ID Modelo        :   " + idCar);
        console.log("5. Concesionaria    :   " + concesionarioDetail);
        console.log("5. Concesionaria    :   " + leadConcesionariaPreferida);
        console.log("6. ID Concesionaria :   " + concesionarioIDDetail);
        console.log("6. ID Concesionaria :   " + concesionarioIDDetail2);
        console.log("6. ID Concesionaria :   " + concesionarioIDDetail3);
        console.log("7. Provincia        :   " + provinciaDetail);
        console.log("7. Provincia        :   " + leadProvincia);
        console.log("*********************************************************");
        */

        const normalize = (str = "") =>
            str
                .toUpperCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");

        const vehiculoNorm = normalize(vehiculoInteresDetail);

        // Verifica si alguno de los modelos en el arreglo MODELSPREVENTA está incluido
        const isPreventa = MODELSPREVENTA.some((modelo) =>
            vehiculoNorm.includes(normalize(modelo))
        );

        if (isPreventa) {
            const funGetEstado = async () => {
                getEstados().then((responseEstados) => {
                    setEstados(responseEstados.data);
                });
            };
            const funGetCiudades = async () => {
                getCiudades().then((responseCiudades) => {
                    setCiudades(responseCiudades.data);
                });
            };

            const funGetConcesionarios = async () => {
                getConcesionarios().then((responseConcesionarios) => {
                    const filterConcesionarios = getOnlyAudiCenters(responseConcesionarios.data.data);
                    setConcesionarios(filterConcesionarios);
                });
            };

            funGetEstado();
            funGetCiudades();
            funGetConcesionarios();
        } else {
            dispatch(setConcesionarioAction(concesionarioDetail));
            dispatch(setIdConcesionarioAction(parseInt(concesionarioIDDetail3, 10)));
            dispatch(setCiudadAction(provinciaDetail));
        }


        setModelToShow(vehiculoInteresDetail);
        setCaracteristicasToShow(vehiculoInteresDescriptionDetail);

        dispatch(setVehiculoAction(vehiculoInteres));
    }, [setModelToShow, setCaracteristicasToShow, dispatch, setConcesionarioAction, setIdConcesionarioAction, setCiudadAction, setVehiculoAction]);

    return (
        <>
            <main className="vtp-nuevos">
                <Stage title={infoNameForm} img={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/" + infoImage} />
                <div className="button-back-container">
                    <ButtonBack />
                </div>
                <section className="container w-100 pt-3">

                    <p className="mb-5">
                        Por favor completa el siguiente formulario. Nos pondremos en contacto contigo para resolver tus dudas y brindarte la información que necesitas sobre tu Audi.
                    </p>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3 vtp-model-info">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <h2 className="vtp_model">{modelToShow}</h2>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <h3 className="vtp_model_description">{caracteristicasToShow}</h3>
                        </div>
                        {!modelToShow.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(MODELSPREVENTA) && (
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <p className="vtp_model_dealer"><b>Concesionario: </b> {objSubmit.concesionariaPreferida}</p>
                            </div>
                        )}
                    </div>

                    <form className="w-100 pt-5" onSubmit={onSubmit}>
                        <TratoComponent value={objSubmit.tratamiento} onChange={(e) => { setTratamiento(e.target.value) }} />
                        <h3>Datos de contacto</h3>
                        <div className="fields-grid mt-4 mb-5">
                            <div className="order-1">
                                <InputText
                                    label="¿Cuál es tu nombre?"
                                    name="nombre"
                                    maxLength={40}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        e.target.value = value;
                                        setNombre(value);
                                    }}
                                    validator={validarNombre}
                                    errorMessage={objSubmit.nombre.length > 40 ? "Máx. 40 cáracteres" : "Carácter no válido, por favor usa solo letras."}
                                />
                            </div>
                            <div className="order-2">
                                <InputText
                                    label="¿Cuál es tu apellido?"
                                    name="apellidoPaterno"
                                    maxLength={80}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        e.target.value = value;
                                        setApellidoPaterno(value);
                                    }}
                                    errorMessage={objSubmit.apellidoPaterno.length > 80 ? "Máx. 80 cáracteres" : "Carácter no válido, por favor usa solo letras."}
                                    validator={validarApellidoPaterno}
                                />
                            </div>
                            <div className="order-3">
                                <InputText
                                    label="¿Cuál es tu número móvil?"
                                    name="movil"
                                    maxLength={10}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10) {
                                            setMovil(e.target.value);
                                        }
                                    }}
                                    errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                    validator={validarCelular}
                                />
                            </div>
                            <div className="order-4">
                                <InputText
                                    label="¿Cuál es tu e-mail?"
                                    name="correo"
                                    maxLength={80}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 80)
                                            setCorreo(e.target.value);
                                    }}
                                    errorMessage="Por favor usa un e-mail válido con formato: nombre@dominio.com"
                                    validator={validarCorreo}
                                />
                            </div>
                            {
                                modelToShow.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(MODELSPREVENTA) &&
                                <div className="order-6 order-lg-4">
                                    <InputSelect
                                        label="Estado"
                                        name="estado"
                                        options={estados.map((item, i) => ({
                                            value: item.nombreedo,
                                            label: item.nombreedo,
                                        }))}
                                        onChange={(e) => {
                                            setEstado(e.target.value);
                                            setIdConcesionario("");
                                            setConcesionario("");
                                        }}
                                        errorMessage="Selecciona una opción"
                                        showError={showErrorEstado}
                                        defaultValue={objSubmit.provincia}
                                    />
                                </div>
                            }
                            {
                                modelToShow.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(MODELSPREVENTA) &&
                                <div className="order-7 order-lg-6">
                                    <InputSelect
                                        label="Ciudad"
                                        name="ciudad"
                                        options={filterCiudades.map((item, i) => ({
                                            value: item.nombrecd,
                                            label: item.nombrecd,
                                        }))}
                                        onChange={(e) => {
                                            setCiudad(e.target.value);
                                        }}
                                        disabled={objSubmit.provincia === ""}
                                        showError={showErrorCiudad}
                                        errorMessage="Selecciona una opción"
                                        defaultValue={objSubmit.ciudad}
                                    />
                                </div>
                            }
                            <div className="order-8">
                                <InputText
                                    label="¿Cuál es tu código postal?"
                                    name="codigoPostal"
                                    value={codigoPostal}
                                    maxLength={5}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 5) {
                                            setCodigoPostal(e.target.value);
                                        }
                                    }}
                                    showError={showErrorCodigoPostal}
                                    errorMessage="Ingresa un código postal válido"
                                    defaultValue={codigoPostal}
                                    validator={validarCodigoPostal}
                                />
                            </div>
                        </div>
                        <h3 className="pt-5">Información de interés</h3>
                        {
                            modelToShow.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(MODELSPREVENTA) &&
                            <div className="w-100 d-flex flex-column flex-md-row gap-5 mt-4 mb-5">
                                <div className="fields-grid">
                                    <InputSelect
                                        label="Concesionario"
                                        name="concesionario"
                                        options={filterConcesionarios.map((item, i) => ({
                                            value: item.dealerNumber,
                                            label: item.name,
                                        }))}
                                        onChange={(e) => {
                                            const concesionario = concesionarios.find(
                                                (con) => con.dealerNumber === parseInt(e.target.value)
                                            );

                                            setIdConcesionario(concesionario.dealerNumber);
                                            setConcesionario(concesionario.name);
                                        }}
                                        showError={showErrorConcesionario}
                                        noDataMessage={objSubmit.provincia === "" ? "Para seleccionar el concesionario, por favor, primero selecciona tu estado" : "No hay concesionarios, por favor, selecciona otro estado."}
                                        showNoDataMessage={objSubmit.provincia !== ""}
                                        errorMessage="Selecciona una opción"
                                        defaultValue={objSubmit.numeroConcesionaria}
                                    />
                                </div>
                            </div>
                        }
                        <div>
                            <InputTextArea
                                name="comentarios"
                                placeholder="Escribe aquí las dudas o información que te gustaría conocer."
                                errorMessage="Tu comentario excede los 1,000 caracteres"
                                maxLength={1000}
                                onChange={(e) => {
                                    setComentarios(e.target.value);
                                }}
                                isValid={true}
                            />
                        </div>

                        <TradeInSection onTradeInChange={setTradeInData} />
                        <div className="mt-5 pt-5">
                            <h3 >Estamos comprometidos con tu privacidad</h3>
                            <p className="mt-4 pb-5">
                                En Audi usamos la información que nos proporcionas para ofrecerte contenido de valor sobre los productos y servicios con los que contamos. Permítenos brindarte una mejor experiencia, a través de un contacto personalizado al aceptar los siguientes avisos:
                            </p>

                            <div className="d-flex flex-column gap-3">
                                <InputCheckBox
                                    rounded
                                    label="Aceptar todo"
                                    onChange={(e) => {

                                        var checkboxes =
                                            document.getElementsByName("checkboxgroup");

                                        checkboxes.forEach((cbx) => {
                                            cbx.checked = e.target.checked;
                                        });
                                        setAvisosDePrivacidad(e.target.checked);
                                        setTerminosCondiciones(e.target.checked);
                                        setTransferenciaDeDatos(e.target.checked);
                                    }}
                                />

                                <InputCheckBox
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setAvisosDePrivacidad(e.target.checked);
                                    }}
                                >
                                    <span>
                                        He leído y acepto el{" "}
                                        <a
                                            href="https://www.audi.com.mx/es/tools/navigation/layer/legal/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Aviso de Privacidad.
                                        </a>
                                    </span>
                                </InputCheckBox>
                                <InputCheckBox
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setTerminosCondiciones(e.target.checked);
                                    }}
                                >
                                    <span>
                                        He leído y acepto el{" "}
                                        <a
                                            href="https://www.audi.com.mx/es/tools/navigation/layer/terminos_y_condiciones/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Términos y Condiciones.
                                        </a>
                                    </span>
                                </InputCheckBox>
                                <InputCheckBox
                                    label="Acepto que los datos aquí proporcionados sean transferidos al Concesionario marca Audi que he elegido, para dar seguimiento a mi solicitud."
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setTransferenciaDeDatos(e.target.checked);
                                    }}
                                />

                                <span
                                    className={`inValid-input ${showErrorDeclaraciones ? "" : "d-none"
                                        }`}
                                >
                                    Para continuar, acepta nuestras declaraciones de conformidad.
                                </span>

                            </div>

                        </div>
                        <div>
                            {!loadingSubmit ? (
                                <button className={`button-enviar`} type="submit">
                                    Enviar
                                </button>
                            ) : (
                                <button
                                    className="button-enviar disabled"
                                    type="button"
                                    disabled={true}
                                >
                                    <div className="loading-g loading-send loading-btn">
                                        <div>
                                            <ReactLoading
                                                type="cylon"
                                                color="#fff"
                                                width={"100%"}
                                                height={"58px"}
                                            />
                                        </div>
                                    </div>
                                </button>
                            )}
                        </div>
                        <span
                            className={`mb-5 inValid-input d-block ${!showErrorSubmit ? "d-none" : ""
                                }`}
                        >
                            Hubo un error. Por favor, Intentelo más tarde.
                        </span>
                    </form>
                </section>
            </main>
        </>
    );
};

export default FormVTPNuevo;